<template>
  <div>
    <Header />
    <TestimonialsDetails />
    <Footer />
    <SocialLinks />
  </div>
</template>

<script>
  import Header from '../components/common/Header'
  import TestimonialsDetails from '../components/Testimonials/TestimonialsDetails'
  import Footer from '../components/common/Footer'
  import SocialLinks from '../components/common/SocialLinks'

  export default {
    name: 'Testimonials',
    metaInfo: {
      title: 'Testimonials',
    },
    components: {
      Header,
      TestimonialsDetails,
      Footer,
      SocialLinks
    },
  }
</script>

<style scoped>
</style>